import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ba7dd07"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-innerPage-header h-32 w-full lg:h-48" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo-detran-cidadao" })
], -1))
const _hoisted_2 = { class: "w-full bg-yellow-50 bg-opacity-70" }
const _hoisted_3 = { class: "container flex gap-4 px-4 pt-4 lg:px-8" }
const _hoisted_4 = ["id", "onClick"]
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "w-full bg-green-800 bg-opacity-90 py-4" }
const _hoisted_8 = { class: "container flex h-auto w-full flex-row justify-between gap-3 px-4 py-3 lg:grid lg:grid-cols-7 lg:flex-wrap lg:px-8" }
const _hoisted_9 = { class: "w-full rounded-full bg-yellow-400 py-2 hover:bg-yellow-500" }
const _hoisted_10 = { class: "font-bold uppercase text-gray-800" }
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mx-auto h-6 w-6",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M18 10a.75.75 0 01-.75.75H4.612l5.158 4.96a.75.75 0 11-1.04 1.08l-6.5-6.25a.75.75 0 010-1.08l6.5-6.25a.75.75 0 111.04 1.08L4.612 9.25H17.25A.75.75 0 0118 10z",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mx-auto h-6 w-6",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M2 10a.75.75 0 01.75-.75h12.638L10.23 4.29a.75.75 0 111.04-1.08l6.5 6.25a.75.75 0 010 1.08l-6.5 6.25a.75.75 0 11-1.04-1.08l5.158-4.96H2.75A.75.75 0 012 10z",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "w-full bg-blue-800 bg-opacity-90 py-4" }
const _hoisted_21 = { class: "container flex h-auto w-full flex-row justify-between gap-3 px-4 py-3 lg:grid lg:grid-cols-7 lg:flex-wrap lg:px-8" }
const _hoisted_22 = { class: "w-full rounded-full bg-yellow-400 py-2 hover:bg-yellow-500" }
const _hoisted_23 = { class: "font-bold uppercase text-gray-800" }
const _hoisted_24 = ["value"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mx-auto h-6 w-6",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M18 10a.75.75 0 01-.75.75H4.612l5.158 4.96a.75.75 0 11-1.04 1.08l-6.5-6.25a.75.75 0 010-1.08l6.5-6.25a.75.75 0 111.04 1.08L4.612 9.25H17.25A.75.75 0 0118 10z",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["value"]
const _hoisted_28 = ["value"]
const _hoisted_29 = ["value"]
const _hoisted_30 = ["value"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mx-auto h-6 w-6",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M2 10a.75.75 0 01.75-.75h12.638L10.23 4.29a.75.75 0 111.04-1.08l6.5 6.25a.75.75 0 010 1.08l-6.5 6.25a.75.75 0 11-1.04-1.08l5.158-4.96H2.75A.75.75 0 012 10z",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_32 = [
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.page !== '/')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([2023, 2022], (tab) => {
          return _createElementVNode("div", {
            key: tab,
            id: `tab-${tab}`,
            class: _normalizeClass([{ active: _ctx.activeTab === tab }, "flex-grow cursor-pointer rounded-t-md px-4 py-2 text-2xl text-gray-600 lg:flex-grow-0 lg:px-16 lg:py-3"]),
            onClick: ($event: any) => (_ctx.activeTab = tab)
          }, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(tab), 1)
          ], 10, _hoisted_4)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links[2022], (link, index) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: index,
                to: link.to,
                class: "hidden items-center justify-start lg:flex",
                onClick: ($event: any) => (_ctx.trackClick('Menu', `Menu - ${link.label} - 2022`)),
                style: {"max-width":"10rem"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(link.label), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["to", "onClick"]))
            }), 128)),
            _createElementVNode("button", {
              value: _ctx.getPages(_ctx.page).prev,
              class: "basis-0 my-2 rounded-full bg-yellow-400 py-2 hover:bg-yellow-500 lg:hidden",
              style: {"flex-basis":"16.666667%"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeRoute($event)))
            }, _hoisted_13, 8, _hoisted_11),
            _createElementVNode("select", {
              value: _ctx.page,
              class: "my-2 flex appearance-none justify-center rounded-full border-none bg-yellow-500 py-2 text-center font-bold shadow-sm transition ease-in-out focus:border-yellow-400 focus:ring focus:ring-yellow-400 focus:ring-opacity-50 lg:hidden",
              style: {"flex-basis":"66.666667%"},
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeRoute($event)))
            }, [
              (!_ctx.isInYear(2022, _ctx.page))
                ? (_openBlock(), _createElementBlock("option", {
                    key: 0,
                    disabled: "",
                    value: _ctx.page
                  }, "Selecione uma fase", 8, _hoisted_15))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links[2022], (link, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: index,
                  value: link.to
                }, _toDisplayString(link.label), 9, _hoisted_16))
              }), 128))
            ], 40, _hoisted_14),
            _createElementVNode("button", {
              value: _ctx.getPages(_ctx.page).next,
              class: "my-2 block w-16 rounded-full bg-yellow-400 py-2 hover:bg-yellow-500 lg:hidden",
              style: {"flex-basis":"16.666667%"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeRoute($event)))
            }, _hoisted_19, 8, _hoisted_17)
          ])
        ], 512), [
          [_vShow, _ctx.activeTab === 2022]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links[2023], (link, index) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: index,
                to: link.to,
                class: "hidden items-center justify-start lg:flex",
                onClick: ($event: any) => (_ctx.trackClick('Menu', `Menu ${link.label} - 2023`)),
                style: {"max-width":"10rem"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(link.label), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["to", "onClick"]))
            }), 128)),
            _createElementVNode("button", {
              value: _ctx.getPages(_ctx.page).prev,
              class: "basis-0 my-2 rounded-full bg-yellow-400 py-2 hover:bg-yellow-500 lg:hidden",
              style: {"flex-basis":"16.666667%"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeRoute($event)))
            }, _hoisted_26, 8, _hoisted_24),
            _createElementVNode("select", {
              value: _ctx.page,
              class: "my-2 flex appearance-none justify-center rounded-full border-none bg-yellow-500 py-2 text-center font-bold shadow-sm transition ease-in-out focus:border-yellow-400 focus:ring focus:ring-yellow-400 focus:ring-opacity-50 lg:hidden",
              style: {"flex-basis":"66.666667%"},
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeRoute($event)))
            }, [
              (!_ctx.isInYear(2023, _ctx.page))
                ? (_openBlock(), _createElementBlock("option", {
                    key: 0,
                    disabled: "",
                    value: _ctx.page
                  }, "Selecione uma fase", 8, _hoisted_28))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links[2023], (link, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: index,
                  value: link.to
                }, _toDisplayString(link.label), 9, _hoisted_29))
              }), 128))
            ], 40, _hoisted_27),
            _createElementVNode("button", {
              value: _ctx.getPages(_ctx.page).next,
              class: "my-2 block w-16 rounded-full bg-yellow-400 py-2 hover:bg-yellow-500 lg:hidden",
              style: {"flex-basis":"16.666667%"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeRoute($event)))
            }, _hoisted_32, 8, _hoisted_30)
          ])
        ], 512), [
          [_vShow, _ctx.activeTab === 2023]
        ])
      ])
    ])
  ], 64))
}